import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function smslogin(data) {
  return request({
    url: '/sms/login',
    method: 'post',
    data
  })
}
export function overseas() {
  return request({
    url: '/overseas',
    method: 'get'
  })
}
// export function visitor() {
//   return request({
//     url: '/visitor',
//     method: 'get'
//   })
// }

export function getInfo(token) {
  return request({
    url: '/getSysUserInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}
